import { render } from "./LatestTransaction.vue?vue&type=template&id=79285dd3&ts=true"
import script from "./LatestTransaction.vue?vue&type=script&lang=ts"
export * from "./LatestTransaction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__